import nuvraLogo from "@/assets/nuvra-logo.png";

interface NuvraLogoProps {
  size?: number;
  className?: string;
  /**
   * Set where the mark sits directly beside a visible "Nuvra" wordmark, as it does in the
   * header and the footer. There the image carries no information the sighted reader is not
   * already given, so alt="Nuvra" makes a screen reader announce the lockup twice, and if the
   * image ever fails to load the browser paints its alt text next to the wordmark and the page
   * literally reads "Nuvra Nuvra". Decorative marks are hidden from assistive technology
   * instead. Defaults to false, so a mark standing alone keeps its accessible name.
   */
  decorative?: boolean;
}

export function NuvraLogo({ size = 32, className = "", decorative = false }: NuvraLogoProps) {
  return (
    <img
      src={nuvraLogo}
      alt={decorative ? "" : "Nuvra"}
      aria-hidden={decorative || undefined}
      width={size}
      height={size}
      className={`rounded-lg ${className}`}
    />
  );
}
